module.exports = __webpack_public_path__ + "img/MO.23e123b4.png";